import { apiGet, queryString, type ApiResult } from "./client";
import type { CenterDay, ChangesPage, SchoolDay } from "./types";

/** All centers' day with the "Needs attention" list (SPEC §7.2 "All centers"). */
export async function fetchSchoolDay(date: string): Promise<ApiResult<SchoolDay>> {
  return apiGet<SchoolDay>("/day" + queryString({ date }));
}

export async function fetchCenterDay(centerId: string, date: string): Promise<ApiResult<CenterDay>> {
  return apiGet<CenterDay>(`/centers/${centerId}/day` + queryString({ date }));
}

export interface ChangesFilter {
  from: string;
  to: string;
  entityType: string | null;
  page: number;
}

export async function fetchChanges(filter: ChangesFilter): Promise<ApiResult<ChangesPage>> {
  return apiGet<ChangesPage>("/changes" + queryString({ ...filter }));
}
